import { render, staticRenderFns } from "./ConsultValidationMat.vue?vue&type=template&id=20f9c805&scoped=true"
import script from "./ConsultValidationMat.vue?vue&type=script&lang=js"
export * from "./ConsultValidationMat.vue?vue&type=script&lang=js"
import style0 from "./ConsultValidationMat.vue?vue&type=style&index=0&id=20f9c805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9c805",
  null
  
)

export default component.exports